export default {
  header: '',
  first_row : '',
  quantities: ['10', '25', '50', '100'],
  bom_parameters : [],
};
